import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCreateGoal = createAsyncThunk(
  "fetchCreateGoal",
  async ( {data},{rejectWithValue} ) => {
    try{
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      const response = await axiosHttp.post(`goal/create`, data, config);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
);

const createGoalSlice = createSlice({
  name: "createGoal",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCreateGoal.pending, (state, action) => {
      state.isError = false;
      state.isLoading = true;
    });

    builder.addCase(fetchCreateGoal.fulfilled, (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCreateGoal.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default createGoalSlice.reducer;